var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdminManagemen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/user-octagon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user-octagon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5667 7.15002V12.85C17.5667 13.7833 17.0667 14.65 16.2583 15.125L11.3083 17.9834C10.5 18.45 9.49999 18.45 8.68332 17.9834L3.73332 15.125C2.92499 14.6584 2.42499 13.7917 2.42499 12.85V7.15002C2.42499 6.21668 2.92499 5.34998 3.73332 4.87498L8.68332 2.01666C9.49165 1.54999 10.4917 1.54999 11.3083 2.01666L16.2583 4.87498C17.0667 5.34998 17.5667 6.20835 17.5667 7.15002Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 9.16667C11.0724 9.16667 11.9417 8.29734 11.9417 7.22499C11.9417 6.15263 11.0724 5.28336 10 5.28336C8.92766 5.28336 8.05835 6.15263 8.05835 7.22499C8.05835 8.29734 8.92766 9.16667 10 9.16667Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.3334 13.8833C13.3334 12.3833 11.8417 11.1667 10 11.1667C8.15835 11.1667 6.66669 12.3833 6.66669 13.8833",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdminManagemen);
export default __webpack_public_path__ + "static/media/icon_admin_managemen.10bbeafff417d0230e710dab2df91a1f.svg";
export { ForwardRef as ReactComponent };